import React, { ComponentProps } from "react";
import InputShell, { Props as InputShellProps } from "./InputShell";
import { BiSearch } from "react-icons/bi";
import { cn } from "@/utils/cn";
import Button from "../button/Button";

type Props = {
  onChange: (newValue: string) => void;
  value: string;
  isIconSearch?: boolean;
  withButton?: boolean;
  buttonLabel?: React.ReactNode;
  onClick?: (newValue: string) => void;
  transformInput?: (value: string) => string;
} & Omit<InputShellProps, "children"> &
  Omit<ComponentProps<"input">, "onChange">;

function Input({
  label,
  onChange,
  value,
  error,
  isOptional,
  isIconSearch = false,
  withButton = false,
  buttonLabel = "",
  transformInput = (value) => value.toUpperCase(),
  className,
  onClick,
  errorclassname,
  ...rest
}: Props) {
  const inputShell = {
    label,
    error,
    errorclassname,
    ...(isOptional
      ? { isOptional, optionalLabel: rest.optionalLabel }
      : { required: rest.required })
  };
  return (
    <InputShell {...inputShell}>
      <div
        className={cn(
          (isIconSearch || withButton) &&
            "flex w-full items-center rounded-[0.25rem] border border-outline transition-all focus-within:border-primary-base",
          withButton && "d-flex"
        )}
      >
        {isIconSearch && <BiSearch className="ml-2.5 !text-[#9BA5B7]" />}
        <input
          className={cn(
            "min-h-[2.5rem] w-full rounded-[0.25rem] px-3 text-sm leading-4 placeholder:text-[#9BA5B7] disabled:bg-slate-100  disabled:text-slate-500",
            withButton && "w-5/6 !rounded-r-none !border-r-0",
            isIconSearch || withButton
              ? "flex-1 border-none placeholder:text-[#9BA5B7] focus:outline-none focus:ring-0"
              : "rounded-[0.25rem] border border-outline",
            className
          )}
          title={label}
          onChange={(e) =>
            onChange(transformInput ? transformInput(e.target.value) : e.target.value)
          }
          value={value}
          autoComplete="off"
          {...rest}
        />
        {withButton && (
          <Button
            className="h-[2.5rem] !rounded-l-none !rounded-r-md border-0"
            variant="gray"
            onClick={() => onClick(value)}
          >
            {buttonLabel}
          </Button>
        )}
      </div>
    </InputShell>
  );
}

export default Input;
